import type { EffectDefinition, EffectContext } from './types'

interface Petal {
  x: number
  y: number
  size: number
  rotation: number
  rotationSpeed: number
  speedY: number
  speedX: number
  swayPhase: number
  swayAmplitude: number
  opacity: number
}

function createPetal(width: number, height: number): Petal {
  return {
    x: Math.random() * width * 1.2 - width * 0.1,
    y: -10 - Math.random() * 60,
    size: 3 + Math.random() * 5,
    rotation: Math.random() * Math.PI * 2,
    rotationSpeed: (Math.random() - 0.5) * 3,
    speedY: 25 + Math.random() * 35,
    speedX: 10 + Math.random() * 20,
    swayPhase: Math.random() * Math.PI * 2,
    swayAmplitude: 0.5 + Math.random() * 1.5,
    opacity: 0.2 + Math.random() * 0.4
  }
}

export const sakura: EffectDefinition = {
  id: 'sakura',
  name: 'Sakura',

  init(ctx: EffectContext) {
    const count = Math.floor((ctx.width * ctx.height) / 8000)
    const petals: Petal[] = []
    for (let i = 0; i < count; i++) {
      const petal = createPetal(ctx.width, ctx.height)
      petal.y = Math.random() * ctx.height
      petals.push(petal)
    }
    return petals
  },

  update(state: unknown, ctx: EffectContext) {
    const petals = state as Petal[]
    const dt = ctx.deltaTime / 1000
    for (const petal of petals) {
      petal.y += petal.speedY * dt
      petal.x += petal.speedX * dt + Math.sin(ctx.time / 1000 + petal.swayPhase) * petal.swayAmplitude * dt * 20
      petal.rotation += petal.rotationSpeed * dt
      if (petal.y > ctx.height + 20) {
        Object.assign(petal, createPetal(ctx.width, ctx.height))
      }
    }
  },

  draw(state: unknown, ctx: EffectContext) {
    const petals = state as Petal[]
    const { ctx: c } = ctx

    for (const petal of petals) {
      c.save()
      c.translate(petal.x, petal.y)
      c.rotate(petal.rotation)

      // Petal shape (two overlapping ellipses)
      c.beginPath()
      c.ellipse(-petal.size * 0.2, 0, petal.size * 0.6, petal.size * 0.3, 0, 0, Math.PI * 2)
      c.fillStyle = `rgba(255, 180, 200, ${petal.opacity})`
      c.fill()

      c.beginPath()
      c.ellipse(petal.size * 0.2, 0, petal.size * 0.6, petal.size * 0.3, 0.3, 0, Math.PI * 2)
      c.fillStyle = `rgba(255, 160, 190, ${petal.opacity * 0.8})`
      c.fill()

      c.restore()
    }
  }
}
